<footer class="footer">
  <div class="footer-copyright">
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-xs-12">
          <div class="copy-right text-left">{{'copyright' | translate}}</div>
        </div>
        <div class="col-md-6 col-xs-12">
          <ul class="social-media">
            <li *ngFor="let social of socialMedia">
              <!-- Ensure the link has an href binding -->
              <a [href]="social.url" [target]="'_blank'" rel="noopener noreferrer">
                <i [ngClass]="social.icon"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</footer>
